import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

const NewComment = ({
  onSubmit,
  setShowCommentsInput,
  showCommentsInput,
  versionKey,
}) => {
  const [commentCopy, setCommentCopy] = useState('');
  const [postDisabled, setPostDisabled] = useState(true);

  const commentInput = useRef();

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ versionKey, note: commentCopy });
    setCommentCopy('');
    setPostDisabled(true);
    setShowCommentsInput(false);
  };

  const handleCloseButton = () => {
    setShowCommentsInput(false);
    setCommentCopy('');
  };

  useEffect(() => {
    if (commentCopy) {
      setPostDisabled(false);
    } else {
      setPostDisabled(true);
    }
  }, [commentCopy]);

  useEffect(() => {
    if (showCommentsInput) {
      commentInput.current.focus();
    }
  }, [showCommentsInput]);

  return (
    <form
      className={`comment-input-container ${showCommentsInput ? 'active' : ''}`}
      onSubmit={handleSubmit}
    >
      <div className="comment-header">
        <p>{t('Leave a comment')}</p>
        <button
          className={`clear-comment-copy ${commentCopy.length ? 'active' : ''}`}
          onClick={() => handleCloseButton()}
          type="button"
        >
          <span className="bff-close" />
        </button>
      </div>
      <textarea
        ref={commentInput}
        className="bf-textarea"
        onChange={(e) => setCommentCopy(e.target.value)}
        placeholder={t('Leave a comment')}
        value={commentCopy}
      />
      <button
        className="button primary sm post-button"
        disabled={postDisabled}
        type="submit"
      >
        {t('Post')}
      </button>
    </form>
  );
};

NewComment.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  setShowCommentsInput: PropTypes.func.isRequired,
  showCommentsInput: PropTypes.bool.isRequired,
  versionKey: PropTypes.string.isRequired,
};

export default NewComment;
